import { forwardRef } from 'react';
import { cn } from 'lib/utils';
import { getLabelAnimationClasses } from './nav-item-constants';

interface NavItemLabelProps {
  children: React.ReactNode;
  isCollapsed: boolean;
  className?: string;
}

export const NavItemLabel = forwardRef<HTMLSpanElement, NavItemLabelProps>(
  ({ children, isCollapsed, className }, ref) => {
    return (
      <span
        ref={ref}
        className={cn(getLabelAnimationClasses(isCollapsed), className)}
      >
        {children}
      </span>
    );
  }
);

NavItemLabel.displayName = 'NavItemLabel';
